module.exports = __webpack_public_path__ + "img/bg5.f104437e.png";